// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".center[data-v-3c12f86d] {\n  text-align: center;\n}", ""]);
// Exports
module.exports = exports;
